export const ExperienceData = [
  {
    title: 'Full Stack Engineer',
    companyname: "CheTu",
    detail:
      "Developed and modified 20+ Single Page Web applications from scratch using React, Angular, Vue.js, REST API, PostgreSQL, Node.js and AWS",
    image: process.env.PUBLIC_URL + '/images/hiring_icon.png',
    progress: '',
    time: 'Sep 2020 - Feb 2023',
  },
  {
    title: 'Blockchain Developer',
    companyname: "Axoni",
    detail:
      'Developed 10+ applications with frontend and backend by React, Web3 and Laravel',
    image: process.env.PUBLIC_URL + '/images/hiring_icon.png',
    progress: '',
    time: 'Feb 2020 - Aug 2020',
  },
  {
    title: 'Full Stack Developer',
    companyname: "Ironhack",
    detail:
      'Developed 10+ marketplace mobile apps with React Native, Flutter and AWS',
    image: process.env.PUBLIC_URL + '/images/hiring_icon.png',
    progress: '',
    time: 'May 2018 - Nov 2019',
  },
  {
    title: 'Frontend Developer',
    companyname: "Deezer",
    detail:
      'Hired as a Frontend Developer, developed 20+ SPAs with React, Redux, Next, Vue, Nuxt, Angular and TypeScript',
    image: process.env.PUBLIC_URL + '/images/hiring_icon.png',
    progress: '',
    time: 'Nov 2015 - Apr 2018',
  },


]
